import { c as _c } from "react/compiler-runtime";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import CreateWaveOutcomesRow from "./CreateWaveOutcomesRow";
export default function CreateWaveOutcomesRows(t0) {
  const $ = _c(12);
  const {
    waveType,
    errors,
    outcomes,
    setOutcomes
  } = t0;
  let t1;
  if ($[0] !== outcomes || $[1] !== setOutcomes) {
    t1 = index => {
      setOutcomes(outcomes.filter((_, i) => i !== index));
    };
    $[0] = outcomes;
    $[1] = setOutcomes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const removeOutcome = t1;
  let t2;
  if ($[3] !== errors) {
    t2 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.OUTCOMES_REQUIRED);
    $[3] = errors;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const showNoOutcomesError = t2;
  let t3;
  if ($[5] !== outcomes || $[6] !== removeOutcome || $[7] !== showNoOutcomesError || $[8] !== waveType) {
    t3 = outcomes.length ? outcomes.map((outcome, i_0) => <CreateWaveOutcomesRow key={i_0} waveType={waveType} outcome={outcome} removeOutcome={() => removeOutcome(i_0)} />) : <span className={`${showNoOutcomesError ? "tw-text-error" : "tw-text-iron-500"} tw-text-sm sm:tw-text-md tw-italic tw-transition tw-duration-300 tw-ease-out`}>No outcomes added</span>;
    $[5] = outcomes;
    $[6] = removeOutcome;
    $[7] = showNoOutcomesError;
    $[8] = waveType;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-4">{t3}</div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}